const EQUIPMENT_MIRROR_SUFFIX = /__equip-\d+$/;

export function stripEquipmentMirrorSuffix(taskId: string): string {
  return taskId.replace(EQUIPMENT_MIRROR_SUFFIX, '');
}

export function parseScheduleIdFromTaskId(taskId: string | null | undefined): number | null {
  if (!taskId) return null;
  const baseId = stripEquipmentMirrorSuffix(taskId);

  const operationMatch = baseId.match(/(?:^|_)operation_(\d+)$/);
  const compactMatch = baseId.match(/^(?:op|tw)_\d+_(\d+)$/);
  const parsed = Number(operationMatch?.[1] ?? compactMatch?.[1]);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function uniqueScheduleIdsFromTaskIds(taskIds: string[]): number[] {
  const seen = new Set<number>();
  const scheduleIds: number[] = [];
  for (const taskId of taskIds) {
    const scheduleId = parseScheduleIdFromTaskId(taskId);
    if (!scheduleId || seen.has(scheduleId)) continue;
    seen.add(scheduleId);
    scheduleIds.push(scheduleId);
  }
  return scheduleIds;
}
